import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { useEffect, useState } from 'react';
import { ADD_ON_CARD } from '../../constants/tracking/TrackingSources';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { billingNameKeySelector, productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import { useQueryParamTerm } from '../../utils/urls/appQueryParamUtils';
import SkeletonLoadWrapper from '../common/loading/SkeletonLoadWrapper';
import ErrorBoundary from '../error-boundary/ErrorBoundary';
import { AddOnCardCTA } from './AddOnCardCTA';
import { AddOnCardCTAFallback, AddOnCardPricingFallback } from './AddOnCardFallbacks';
import AddOnCardLayoutUI from './AddOnCardLayoutUI';
import { AddOnCardPricing } from './AddOnCardPricing';
import { jsx as _jsx } from "react/jsx-runtime";
export const AddOnCard = ({
  screen,
  skuId
}) => {
  const [ctaDebouncing, setCtaDebouncing] = useState(true);

  // intentionally slowdown the cta button from rendering so that when searching / filtering add-ons,
  // the cta button doesn't render immediately (it's an expensive operation)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setCtaDebouncing(false);
    }, 300);
    return () => {
      clearTimeout(timeout);
    };
  });
  const {
    queryParamTerm
  } = useQueryParamTerm();
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const isAppReady = useGlobalLoading();
  const productConfigurations = [createProductConfig({
    skuId,
    quantity: selectedQuantity
  })];
  const billingNameKey = useAppSelector(state => billingNameKeySelector(state, {
    skuId
  }));
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  return /*#__PURE__*/_jsx(AddOnCardLayoutUI, {
    "data-test-id": `${ADD_ON_CARD}-${product.apiName}`,
    "data-selenium-id": `${ADD_ON_CARD}-${product.apiName}`,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages.products.${billingNameKey}.title`
    }),
    pricing: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: !isAppReady,
      heights: [18],
      widths: [63],
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        fallback: /*#__PURE__*/_jsx(AddOnCardPricingFallback, {}),
        children: /*#__PURE__*/_jsx(AddOnCardPricing, {
          productConfigurations: productConfigurations,
          skuId: skuId,
          term: queryParamTerm
        })
      })
    }),
    cta: /*#__PURE__*/_jsx(SkeletonLoadWrapper, {
      isLoading: ctaDebouncing || !isAppReady,
      heights: [40],
      widths: [157],
      children: /*#__PURE__*/_jsx(ErrorBoundary, {
        fallback: /*#__PURE__*/_jsx(AddOnCardCTAFallback, {
          skuId: skuId
        }),
        children: /*#__PURE__*/_jsx(AddOnCardCTA, {
          skuId: skuId,
          screen: screen,
          term: queryParamTerm,
          selectedQuantity: selectedQuantity,
          productConfigurations: productConfigurations,
          onQuantityChange: setSelectedQuantity
        })
      })
    }),
    description: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `pricing-pages.products.${billingNameKey}.paragraph`
    })
  });
};
export default AddOnCard;